import {matchPath, useLocation} from '@github-ui/react-router'

import {REPO_STACK_DETAIL_PATH} from '../../routes/repo-stack-detail-route'
import {REPO_STACKS_LIST_PATH} from '../../routes/repo-stacks-list-route'

export function getStackPage(pathname: string): 'list' | 'detail' | null {
  if (matchPath(REPO_STACKS_LIST_PATH, pathname)) return 'list'
  if (matchPath(REPO_STACK_DETAIL_PATH, pathname)) return 'detail'
  return null
}

export function useStackPage() {
  const {pathname} = useLocation()
  return getStackPage(pathname)
}
